/* Default configuration settings, can be overwritten by the client specif version */

export default class defaultConfig {
  /**
   * If set to `true`, social sharing links for ALBs will be constructed
   * based on the WebappReplicaShareUrl profile value.
   */
  static shareFromReader = false;
  static shareFromNextgen = false;
  static useCookiePostfix = false;

  //kiosque
  /**
   * If set to `true`, a new archive block will be added to the kiosk to
   * display hors series. Hors series are fetched from the Twipe
   * backend API using the `AdditionalDownloadTokens` call. If there
   * are no hors series to show, the archive will be hidden.
   *
   * Default is `true`.
   */
  static displayHorsSerieArchive = true;
  /**
   * If set to `true`, a new archive block will be added to the kiosk to
   * display past main publications.
   *
   * Default is `true`.
   */
  static displayArchive = true;
  /**
   * If set to `true`, a new archive block will be added to the kiosk to
   * display promospots. Promospots are fetched from the Twipe
   * backend API using the `KiosquePublications` call. If there
   * are no promospots to show, the archive will be hidden.
   *
   * Default is `true`.
   */
  static usePromoSpot = true;
  static customKiosqueTitle = "";
  static topNavButtonLabel = "";
  /**
   * Determines the amount of publication to show in the archive.
   * For most clients, this will be 30 publications,
   * since publications are saved for one month in the backend.
   *
   * Default is `30`.
   */
  static archiveLength = 30;
  static toggleSubscriptionTopNavButtonOnUserLoggedIn = false;
  static newsstandRedirecting = null;
  static homeRelativeDepth = 0; /* to stay on the same directory level use -1. CFR uses it. */
  // [
  //   { token: 'TWPPAR75', url: '', redirectingUrl: '/index.html', current: true },  //set current to true if it should be inactivated
  //   { token: 'TWPPAR18H', url: '//par-18h-uat-api.twipecloud.net/', redirectingUrl: '//twipe-par-18h-uat-webreader.s3.amazonaws.com/index.html' },
  //   { token: 'TWPPARECO', url: '', redirectingUrl: '/economie/index.html' },
  //   { token: 'TWPPARETU', url: '', redirectingUrl: '/etudiant/index.html' },
  //   { token: 'TWPPARPSN', url: '', redirectingUrl: '//www.kiosque.laparisienne.com/' },
  // ];

  //promospot
  static onlySupplementsInPromospot = false;

  //swiper
  static numberOfSlidesVisible = { phone: 3.5, tablet: 4.5 };
  static spaceBetweenSlides = { phone: 19, tablet: 40 };

  //sidemenu
  static recentlyLength = 10;
  static sidemenuThema = "light"; //light or dark
  static extraInfo = null; //[{name: 'Site Nieuwsblad', link: 'http://www.nieuwsblad.be'}]; //{'Site Niewsblad': 'www.nieuwsblad.be'};   // example: {'Site Niewsblad': 'www.nieuwsblad.be'} of null
  static homeRedirectionLink = null; // null or link of client home if they provided there own home
  static logo404 = "logo.png";
  static homeRedirectionLinkUAT = null;
  static homeRedirectionLinkPROD = null;

  //sidemenuswiper
  static numberOfSlidesVisibleSideMenu = { phone: 2.3, tablet: 2.3 };
  static spaceBetweenSlidesSideMenu = { phone: 10, tablet: 10 };

  //settings
  static turnOnSettings = true;
  static showPreviewPublications = false;

  //help

  /**
   * If set to true, displays a help button in the top navigation
   * next to the login button.
   *
   * Default is `false`.
   */
  static turnOnHeaderHelp = false;

  //about
  static editor = "";
  static developer = "Twipe";

  //regionmanager
  static defaultRegion = false;
  static defaultDownloadToken = null;
  static downloadToken = null;

  // ---------------------------------------
  // AUTHENTICATION AND SSO (SINGLE SIGN-ON)
  // ---------------------------------------

  /**
   * If set to `true`, enables SSO login.
   */
  static SSOEnabled = false;
  /**
   * When authenticating via SSO,
   * the webapp will look for a cookie with a name
   * equal to the value of this config.
   *
   * Only relevant if SSO login is enabled.
   */
  static SSOCookieName = "PubSSOToken";
  /**
   * Can be set to an object containing extra properties of the SSO cookie.
   * This is typically a `path` and a `domain`.
   *
   * Only relevant if SSO login is enabled.
   */
  static SSOCookieOptions = { path: "", domain: "" };
  /**
   * If set to `true`, the SSO token will be fetched
   * from the URL after logging in via SSO.
   *
   * Only relevant if SSO login is enabled.
   */
  static getSSOTokenFromUrl = false;
  /**
   * If set to `true`, the method `_removeSSOCookie()` will always work.
   * Otherwise, it will only work under certain circumstances.
   *
   * Only relevant if SSO login is enabled.
   */
  static deleteSSOCookie = true;
  /**
   * If set to true, the SSO state will be stored in a cookie.
   * Otherwise, SSO state is managed via URL parameters.
   *
   * Only relevant if SSO login is enabled.
   */
  static generateSSOState = false;
  /**
   * When fetching the SSO token from URL, the webapp will look in the URL
   * for a parameter of which the name matches the value of this config.
   *
   * Only relevant if SSO login is enabled.
   */
  static urlSSOTokenParameter = "token";

  // --------------------
  // SUBSCRIPTION OPTIONS
  // --------------------

  /**
   * Allows for setting extra options related to subscriptions and login.
   * Typically this consists of two things:
   *
   * - `subscriptionType`: `free` or `subscription`
   * - `subscriptionProvider`: the provider of the subscription. Will be passed along when doing
   * a `validateSubscription` call to the backend.
   */
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "TWIPE-DEMO",
  };

  //cookie
  static cookie_info_cookie_name = "TW_COOKIE";
  static cookieEnabled = false;

  //reader
  static useFullWidthLandscapeSinglePage = { phone: true, tablet: true };
  static useFullWidthLandscapeDoublePage = { phone: false, tablet: false };
  static redirectReaderFromIframe = false; // Config to make the full page redirect to the reader when in an iframe
  static returnToIframeurl = null;

  /**
   * An object which represents if toggle buttons should be displayed for
   * changing the reading mode between single page and double page. The toggle
   * buttons can be made visible per device type.
   *
   * Default is `true` for tablets, `false` for phones and desktops.
   */
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: false,
  };
  /**
   * An object which represents in which reading mode the reader should
   * start initially. `false` means single page, `true` means double page.
   * The initial reading mode can be configured per device type.
   *
   * Default is `true` for tablets and desktops, `false` for phones.
   */
  static replicaReadingModeDefault = {
    phone: false,
    tablet: true,
    desktop: true,
  };

  static enableTopNavDropdown = false;

  // hammerSlide
  static pinchPanTimeInterval = 50; //time between pinch and pan to accept pan event
  static pinchTreshold = 0.1; //treshold for when to accept pinch
  static max_zoom = 5;
  static page_ratio = 1.5;

  //readerPage
  static normal_size = "900/900"; //should be set for each client, depends on the packager wwhat sizes he produces
  static hd_size = "2600/1928";
  static page_width_reference = 150000;
  static page_height_reference = 150000;
  /**
   * Determines where enrichments are placed vertically inside the clickable area
   * of an article. Options are `"top"`, `"bottom"` and `"center"`.
   *
   * Default is `"top"`.
   */
  static enrichment_placement_vertical = "top"; // [top || bottom || center];
  /**
   * Determines where enrichments are placed horizontally inside the clickable area
   * of an article. Options are `"left"`, `"right"` and `"center"`.
   *
   * Default is `"left"`.
   */
  static enrichment_placement_horizontal = "left"; // [left || right || center];

  static pdfThreshold = { width: 1270, height: 1750 };
  static pdfThresholdTouch = { width: 800, height: 1300 };
  static pdfLoadingTimeout = 200;
  static pdfCleanupDelta = 2;

  static activeAreaPercentage = 0.8;

  //albcontroller
  static extraButtonOnSlider = true;
  static increaseFontSizeEnabled = true;
  static albSlideOnlyOnePage = false;
  static rootFontSize = 10; //set in px
  static fontSizeStep = 2;
  static maxfontSize = 20;
  static extraUrlDirectAccess = false;

  //tag::sharing
  /**
   * Determines whether social sharing is allowed in the ALB.
   * This does not guarantee that the sharing button will appear,
   * as this also depends on other factors (including the social sharing
   * link that has to be fetched from backend).
   */
  static sharingEnabled = true;
  //tag::sharingOptions[]
  static sharingOptions = {
    Facebook: true,
    WhatsApp: true,
    TwitterX: true,
    Mail: true,
    MailSubject: null,
    MailSubjectIntro: "",
    useArticleMainImageInReplica: false,
  };
  //end::sharingOptions[]
  //end::sharing[]

  //tag::sharingLandingBanner[]
  /**
   * @type {Object}
   * @property {boolean} enabled - Whether the sharing landing banner is enabled.
   * @property {string | undefined} signupLink - The URL to redirect to when the signup button is clicked.
   */
  //tag::sharingLandingBanner-code[]
  static sharingLandingBanner = {
    enabled: false,
    signupLink: undefined,
  };
  //end::sharingLandingBanner-code[]
  //end::sharingLandingBanner[]

  //alb slide
  static fixedImgHeight = true; //TODO: remove config?
  static captionMaxLines = false;
  static extraButtonInTitle = false;
  static hideExtraButtonWhenInExtras = false;
  static extraButtonOnEachPage = false;
  static extrasInViewMargin = 50; //when to hide button
  static fullWidthImage = false;
  static marginScrollExtraInView = 30;
  static displayPageCategory = false;

  //imageviewer
  static imageviewerKeepScale = true;

  //imageviewerslide
  static imageViewerCaptionOnlyFirstLines = true; //if the caption of the imageViewershould be resricted in lines and clickable to expand

  static get page_reference_ratio() {
    return this.page_height_reference / this.page_width_reference;
  }
  static channel = 3;

  // Edition analytics
  static product_name_for_engage_readers = "Dagkrant";

  //reader
  static bottomNavigation = true;
  static thumbsNavigation = true;

  static thumbSliderExtraSlidesVisible = { phone: 1, tablet: 2 };

  static positionExtraButton = { horizontal: "right", vertical: "bottom" };
  static readerEnableHorsseries = false;

  static preloadingHdPages = 1;

  static useCustomTooltips = false;
  /**
   * If set to `true`, displays text labels underneath icons in the
   * top navigation bar.
   *
   * This config can only be enabled if the useCustomTooltips is disabled,
   * because it does not make sense to have both.
   *
   * Default is `false`.
   */
  static displayTopNavButtonlabel = false;

  /**
   * @typedef {Object} pdfDownloadButtonsConfig
   * @property {boolean} single - Whether to display the single page download button.
   * @property {boolean} full - Whether to display the full edition download button. Note that a BE configuration is required to generate the full PDF files.
   * @property {boolean} touchDownloadPdf - Whether to display the download button for touch devices.
   */

  /**
   * Defines which download buttons should be displayed in the top navigation bar.
   * @type {pdfDownloadButtonsConfig}
   */
  static pdfDownloadButtonsConfig = {
    single: true,
    full: true,
    touchDownloadPdf: false,
  };

  //image size
  static thumbSize = "240/440"; //should be set for each client, depends on the packager wwhat sizes he produces
  static thumbSizeM = "900/900";
  static thumbSizeL = "900/900";
  static newDownloaderCoverSizeS = "SMALL";
  static newDownloaderCoverSizeM = "MEDIUM";

  // Sizes
  // covers
  static namedSizeCoverS = "SMALL";
  static sizeCoverS = "240/440";
  static namedSizeCoverM = "MEDIUM";
  static sizeCoverM = "900/900";
  // previews
  static namedSizePreviewS = "SMALL";
  static sizePreviewS = "240/440";
  static namedSizePreviewM = "MEDIUM";
  static sizePreviewM = "900/900";
  static namedSizePreviewL = "XLARGE";
  static sizePreviewL = "2600/1928";
  // images
  static namedSizeImageM = "MEDIUM";
  static sizeImageM = "240/440";
  static namedSizeImageL = "XLARGE";
  static sizeImageL = "2600/1928";
  // print
  static printImageSize = "2600/1928";

  static dropCapIfFirstBold = false;

  static dateFormat = "ddd D MMM";

  static sidemenuWidth = { phone: 250, tablet: 320 };
  static sidemenuAnimationDuration = { phone: 0.25, tablet: 0.25 };

  // print
  static printImageSize = "2600/1928";

  static printArticle = true;
  static printExtraMargin = 15;
  static printMarginLeft = 10;
  static printPadding = 10;

  //pdf   : if you enable make sure CORS headers are correctly set in bakckend
  static usePdfTablet = false;
  static usePdfTabletNot = false;
  static usePdfPhone = false;
  static usePdfPhoneNot = false;
  static usePdfDesktop = false;
  static usePdfDesktopNot = false;

  // static usePdfPhoneNot = [
  //   ['Safari', 'iOS', 'version_8'],
  //   ['Safari', 'iOS', 'version_7'],
  // ]
  // static usePdfPhone = [
  //   ['iOS', 'Chrome'],
  //   ['iOS', 'FireFox'],
  //   ['AndroidOS', 'Chrome'],
  // ];

  //zooming
  static desktopMaxZoom = {
    doublePageMode: 5,
    singlePageMode: 3,
  };
  static zoomSteps = 8;

  /**
   * Sets the default preferred viewer (`'replica'` or `'nextgen'`).
   * Default is `'nextgen'`.
   */
  static defaultPreferredViewer = "nextgen";
  /**
   * Determines whether to show options for switching between
   * the Replica and NextGen viewer. This affects the following:
   *
   * - the switch button under the kiosk spotlight edition
   * - the option in the settings menu
   * - the switch icon in the reader
   *
   * Default is `false`.
   */
  static displayViewerOptions = false;

  /**
   * Determines whether click boxes for enrichment articles containing an external link
   * will be opened in a new browser tab, or just in the ALB.
   *
   * Default is `false`, which opens them in the ALB.
   */
  static extraLinkDirectAccess = false;

  static socialSharingHash = false;
  static allowNextgenPageSharing = false;

  static logoRedirect = false;

  static useNameAsLabel = false;

  static useHSNameAsLabel = true;

  static useSliderForPromospot = false;
  static useSliderForHorsSeries = false;

  /**
   * If set to `true`, the main archive is displayed as a single row
   * with slider functionality. Else, all publications in the archive
   * are displayed together in several rows.
   *
   * Default is `false`.
   */
  static useSliderForArchive = false;

  static forceRegionCookie = "TW_FORCE_REGION";
  static forceRegionCookieOptions = { path: "", domain: "" };
  static deleteForceRegionCookie = true;

  /**
   * If set to `true`, the webapp will fetch a redirection url from the Twipe
   * database and redirect users to that URL whenever a paywall should be shown.
   * If set to `false` or `null`, the default paywall of the webapp will be used.
   */
  static paywallRedirectionUrl = null;

  // time in ms
  static paywallRedirectionTimeReset = 1000 * 60 * 2;
  /**
   * Determines how many times a user can be redirected between the Twipe webapp and an external SSO
   * provider. Once this limit is surpassed, the webapp will show its own paywall instead.
   * Default is 1 time.
   */
  static externalPaywallMaxRedirectionNumber = 1;

  static subscription_validate_email = false;

  static cmpScript = "";
  static enableCookieConsent = false;
  static hasConsentScript = false;
  static showBackButtonParam = undefined;
  static urlRedirectParameter = "redirectionUrl";
  static displayPublicationNameInSidebar = false;
  static featuresToBeEnabledByBE = [];
  static disableCookieSameSitePolicy = false;
  static printCroppedPdf = true;
  static openHelpOnNewtab = true;
  static openPrivacyOnNewtab = true;
  static showPrivacyPolicy = false;
  static noPasswordLogin = false;
  static hideDisclaimer = false;
  static singlePageDisplayedProportion = 3; //1/3 of the page is displayed on the screen
  static voucher = {
    isEnabled: false,
    dateFormat: "DD/MM/YYYY",
  };
}



// WEBPACK FOOTER //
// ./src/common/default_config.js